<template>
  <div class="bg-neutral-100 rounded-sm animate-appear" />
</template>
